import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class OriginOfFunds extends KYCQuestion
{
	state = {
		fields: {
			aml_origin_options: {
				options: [
					{
						name: "checkbox_aml_origin_interest",
						label: "Ränta/utdelningar från tidigare sparande",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_aml_origin_salary_pension",
						label: "Lön/pension",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_aml_origin_savings_herit_gift",
						label: "Arv/gåva",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_advice_origin_security_prof",
						label: "Vinst från värdepappershandel",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_advice_origin_lottery",
						label: "Lotteri/spel",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_aml_origin_re",
						label: "Bostads-/fastighetsförsäljning",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_aml_origin_companyexit",
						label: "Företagsförsäljning",
						value: "yes",
						checked: false
					},
					{
						name: "checkbox_aml_origin_insur_payment",
						label: "Försäkringsutbetalning",
						value: "yes",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "aml_origin_options";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					style={{marginTop: "35px"}}
					type="checkbox"
					name="aml_origin_options"
					description="Varifrån kommer dina pengar?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.aml_origin_options.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/OriginOfFunds.js